module.exports = __webpack_public_path__ + "img/rushbg.ea46a8e4.jpg";